import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  private accessToken = '';

  setAccessToken(token: string): void {
    this.accessToken = token;
    localStorage.setItem('accessToken', token);
  }

  getAccessToken(): string {
    if (!this.accessToken) {
      this.accessToken = localStorage.getItem('accessToken') || '';
    }
    return this.accessToken;
  }

  clearAccessToken(): void {
    this.accessToken = '';
    localStorage.removeItem('accessToken');
  }
}
